const forbiddenWords = [
  'Contactez',
  'DM',
  'Instagram',
  'Whatsapp',
  'Facebook',
  'Message',
  'mail',
  'numéro',
  'téléphone',
  'Contact',
  'Contacter',
  'Contactez',
  'Message',
  'Messages',
  'Mail',
  'Mails',
  'deux',
  'trois',
  'quatre',
  'cinq',
  'six',
  'sept',
  'huit',
  'neuf',
  'dix',
  'onze',
  'douze',
  'treize',
  'quatorze',
  'quinze',
  'seize',
  'vingt',
  'trente',
  'quarante',
  'cinquante',
  'soixante',
  'cent',
  'mille',
  'zéro',
  'uno',
  'due',
  'tre',
  'quattro',
  'cinque',
  'sei',
  'sette',
  'otto',
  'nove',
  'dieci',
  'undici',
  'dodici',
  'tredici',
  'quattordici',
  'quindici',
  'sedici',
  'venti',
  'trenta',
  'quaranta',
  'cinquanta',
  'sessanta',
  'cento',
  'mille',
  'zero',
  'eins',
  'zwei',
  'drei',
  'vier',
  'fünf',
  'sechs',
  'sieben',
  'acht',
  'neun',
  'zehn',
  'elf',
  'zwölf',
  'dreizehn',
  'vierzehn',
  'fünfzehn',
  'sechzehn',
  'zwanzig',
  'dreißig',
  'vierzig',
  'fünfzig',
  'sechzig',
  'hundert',
  'tausend',
  'null',
  'one',
  'two',
  'three',
  'four',
  'five',
  'six',
  'seven',
  'eight',
  'nine',
  'ten',
  'eleven',
  'twelve',
  'thirteen',
  'fourteen',
  'fifteen',
  'sixteen',
  'twenty',
  'thirty',
  'forty',
  'fifty',
  'sixty',
  'hundred',
  'thousand',
  'zero',
  'uno',
  'dos',
  'tres',
  'cuatro',
  'cinco',
  'seis',
  'siete',
  'ocho',
  'nueve',
  'diez',
  'once',
  'doce',
  'trece',
  'catorce',
  'quince',
  'dieciséis',
  'veinte',
  'treinta',
  'cuarenta',
  'cincuenta',
  'sesenta',
  'cien',
  'mil',
  'cero',
].join('|')

type MessageSanitizeParams = {
  address?: boolean
  phone?: boolean
  email?: boolean
  social?: boolean
  keywords?: boolean
  emojisNumbers?: boolean
}

export const messageSanitize = (
  message: string,
  params: MessageSanitizeParams = {
    address: true,
    phone: true,
    email: true,
    social: true,
    keywords: true,
    emojisNumbers: true,
  },
): string => {
  let newMessage = message

  params = { address: true, phone: true, email: true, social: true, keywords: true, emojisNumbers: true, ...params }

  // Address
  try {
    newMessage = params.address
      ? newMessage.replace(
          new RegExp('^[0-9]+\\s+([a-zA-Z]+\\s+)+[a-zA-Z]{2,}(\\s+[0-9]{5})?$', 'gim'),
          '🐾🐾🐾🐾🐾🐾🐾',
        )
      : newMessage
  } catch (err) {
    console.error('Cannot sanitize address', err)
  }

  // Phone
  try {
    newMessage = params.phone
      ? newMessage.replace(new RegExp('(\\+|00|0)[1-9][0-9 \\-\\(\\)\\.]{7,32}', 'g'), '🐾🐾🐾🐾🐾🐾🐾')
      : newMessage
  } catch (err) {
    console.error('Cannot sanitize phone', err)
  }

  // Email
  try {
    newMessage = params.email
      ? newMessage.replace(
          new RegExp(
            '(\\+?\\d{2}\\s*(?:\\d\\s*){9})|([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,})|(https?:\\/\\/(?:www\\.)?(?:linkedin|twitter|instagram|facebook)\\.com\\/[a-zA-Z0-9._-]+\\/?)',
            'gim',
          ),
          '🐾🐾🐾🐾🐾🐾🐾',
        )
      : newMessage
  } catch (err) {
    console.error('Cannot sanitize email', err)
  }

  // Social
  try {
    newMessage = params.social
      ? newMessage.replace(new RegExp('(?<=[^\\/]|^)@[A-Za-z0-9_.]{3,25}', 'gim'), '🐾🐾🐾🐾🐾🐾🐾')
      : newMessage
  } catch (err) {
    console.error('Cannot sanitize social', err)
  }

  // KeyWords
  try {
    newMessage = params.keywords
      ? newMessage.replace(new RegExp(`(${forbiddenWords})`, 'gim'), '🐾🐾🐾🐾🐾🐾🐾')
      : newMessage
  } catch (err) {
    console.error('Cannot sanitize keywords', err)
  }

  // Emojis numbers 0-9
  try {
    newMessage = params.emojisNumbers
      ? newMessage.replace(
          new RegExp('(?:\uD83D(?:[#*0-9]\uFE0F?|\uDD1D)|[#*0-9]\uFE0F?\u20E3|\uD83C(?:[0-9]\uFE0F?|\uDF00))', 'g'),
          '🐾🐾🐾🐾🐾🐾🐾',
        )
      : newMessage
  } catch (err) {
    console.error('Cannot sanitize emojisNumbers', err)
  }

  return newMessage
}
